import React, { useState } from 'react';
import { create, InstanceProps } from 'react-modal-promise';

import { useRouter } from 'next/router';
import Modal from 'components/Modal';
import InviteEmail from 'components/InvitePopup/InviteEmail';
import { useCampaigns } from 'lib/contexts/campaigns-context';
import { PAGE_ROUTES } from 'lib/page-routes';
import { OpportunityAttributes } from 'lib/models/opportunity';
import { InviteCandidate } from 'lib/models/candidate';
import { Invite } from '../InviteComponent/Invite.component';

import styles from './InviteGuestModal.module.scss';

interface ModalInstanceProps {
  touchpoint: OpportunityAttributes;
}

const ModalInstance: React.FC<ModalInstanceProps & InstanceProps<void>> = ({
  isOpen,
  onResolve,
  onReject,
  touchpoint,
}) => {
  const router = useRouter();
  const { id: touchpointId } = touchpoint || {};

  const { setInvitePopup, setSelectedEventState } = useCampaigns();

  const [candidateSelected, setCandidateSelected] = useState<
    Array<InviteCandidate>
  >([]);
  const [importedCandidateList, setImportedCandidateList] = useState<
    Array<InviteCandidate>
  >([]);

  const [showInvitingListandEmail, setShowInvitingListandEmail] =
    useState(false);

  const resetStates = () => {
    router.replace(`${PAGE_ROUTES.CAMPAIGNS}/${touchpointId}`, undefined, {
      shallow: true,
    });
    setInvitePopup(false);
    setSelectedEventState(0);
    setShowInvitingListandEmail(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        resetStates();
        onReject();
      }}
      closeOnOverlayClick={false}
      contentClassName={styles.container}
    >
      {showInvitingListandEmail ? (
        <InviteEmail
          candidateSelected={candidateSelected}
          touchpoint={touchpoint}
          onClose={() => {
            resetStates();
            onReject();
          }}
          onModalResolve={() => {
            resetStates();
            onResolve();
          }}
          onBackClick={() => setShowInvitingListandEmail(false)}
        />
      ) : (
        <Invite
          touchpoint={touchpoint}
          candidateSelected={candidateSelected}
          setCandidateSelected={setCandidateSelected}
          importedCandidateList={importedCandidateList}
          setImportedCandidateList={setImportedCandidateList}
          onNextClick={() => setShowInvitingListandEmail(true)}
          onClose={() => {
            resetStates();
            onReject();
          }}
          onModalResolve={() => {
            resetStates();
            onResolve();
          }}
        />
      )}
    </Modal>
  );
};

export const inviteGuestModalInstance = create(ModalInstance);
